/**
 * HighScoreManager - Manages high score persistence via localStorage
 * Stores top 10 scores with name, score, and date.
 */

const STORAGE_KEY = 'missileCommand_highScores';
const MAX_SCORES = 10;

export class HighScoreManager {
  constructor() {
    this.scores = this._load();
  }

  /**
   * Reload scores from localStorage (call before displaying).
   */
  refresh() {
    this.scores = this._load();
  }

  /**
   * Get all high scores sorted by score descending.
   */
  getScores() {
    return [...this.scores];
  }

  /**
   * Check if a score qualifies for the top 10.
   */
  isHighScore(score) {
    if (this.scores.length < MAX_SCORES) return true;
    return score > this.scores[this.scores.length - 1].score;
  }

  /**
   * Add a new high score entry.
   */
  addScore(name, score) {
    const date = new Date().toLocaleDateString();
    this.scores.push({ name, score, date });
    this.scores.sort((a, b) => b.score - a.score);
    this.scores = this.scores.slice(0, MAX_SCORES);
    this._save();
  }

  /**
   * Clear all high scores.
   */
  clearScores() {
    this.scores = [];
    this._save();
  }

  _load() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (data) {
        return JSON.parse(data);
      }
    } catch (e) {
      console.warn('Failed to load high scores:', e);
    }
    return [];
  }

  _save() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.scores));
    } catch (e) {
      console.warn('Failed to save high scores:', e);
    }
  }
}
